import {
  DefaultNodeModel,
  DefaultPortModel,
  PortModelAlignment,
} from "@projectstorm/react-diagrams";

const PORTS_BY_KIND = {
  solution: [
    { name: "solution-in", alignment: PortModelAlignment.TOP, in: true },
    { name: "steps-out", alignment: PortModelAlignment.BOTTOM, in: false },
  ],
  step: [
    { name: "step-in", alignment: PortModelAlignment.TOP, in: true },
    { name: "step-out", alignment: PortModelAlignment.BOTTOM, in: false },
    { name: "groups-out", alignment: PortModelAlignment.RIGHT, in: false },
    { name: "visibility-in", alignment: PortModelAlignment.TOP, in: true },
    { name: "visibility-out", alignment: PortModelAlignment.BOTTOM, in: false },
  ],
  group: [
    { name: "group-in", alignment: PortModelAlignment.LEFT, in: true },
    { name: "inputs-out", alignment: PortModelAlignment.RIGHT, in: false },
    { name: "visibility-in", alignment: PortModelAlignment.TOP, in: true },
    { name: "visibility-out", alignment: PortModelAlignment.BOTTOM, in: false },
  ],
  input: [
    { name: "input-in", alignment: PortModelAlignment.LEFT, in: true },
    { name: "input-out", alignment: PortModelAlignment.RIGHT, in: false },
    { name: "visibility-in", alignment: PortModelAlignment.TOP, in: true },
    { name: "visibility-out", alignment: PortModelAlignment.BOTTOM, in: false },
  ],
};

export default class SolutionFlowNodeModel extends DefaultNodeModel {
  constructor(options) {
    super({
      ...options,
      type: "solution-flow-node",
    });

    this.options.nodeKind = options.nodeKind || "step";
    this.options.title = options.title || "Untitled";
    this.options.subtitle = options.subtitle || "";
    this.options.meta = options.meta || "";

    (PORTS_BY_KIND[this.options.nodeKind] || []).forEach((portConfig) => {
      this.addPort(
        new DefaultPortModel({
          in: !!portConfig.in,
          name: portConfig.name,
          alignment: portConfig.alignment,
        })
      );
    });
  }

  serialize() {
    return {
      ...super.serialize(),
      nodeKind: this.options.nodeKind,
      title: this.options.title,
      subtitle: this.options.subtitle,
      meta: this.options.meta,
      color: this.options.color,
      flowSelection: this.options.flowSelection,
      isFlowFocused: !!this.options.isFlowFocused,
    };
  }

  deserialize(event) {
    super.deserialize(event);
    this.options.nodeKind = event.data.nodeKind;
    this.options.title = event.data.title;
    this.options.subtitle = event.data.subtitle;
    this.options.meta = event.data.meta;
    this.options.color = event.data.color;
    this.options.flowSelection = event.data.flowSelection;
    this.options.isFlowFocused = !!event.data.isFlowFocused;
  }
}
